import React, { useEffect, useCallback } from 'react';
import { ClickAwayListener } from '@material-ui/core';
import { SPopper } from './DatePicker.styled';
export var DatePickerPanel = function (_a) {
    var children = _a.children, anchorEl = _a.anchorEl, open = _a.open, onClose = _a.onClose;
    var keydownEscapeHandler = useCallback(function (e) {
        if (e.key === 'Escape') {
            e.stopPropagation();
            onClose(true);
        }
    }, [onClose]);
    useEffect(function () {
        if (open) {
            document.addEventListener('keydown', keydownEscapeHandler);
            return function () {
                document.removeEventListener('keydown', keydownEscapeHandler);
            };
        }
        return undefined;
    }, [keydownEscapeHandler, open]);
    return (React.createElement(SPopper, { anchorEl: anchorEl, placement: "bottom-start", open: open, disablePortal: true, role: "dialog" },
        React.createElement(ClickAwayListener, { onClickAway: function () { return onClose(false); } }, children)));
};
//# sourceMappingURL=DatePickerPanel.js.map